<script lang="ts">
  import BasketItem from "./BasketItem.svelte";
  import { pushGtmEcommerceEvent } from "$lib/utils/gtmEvent";
  import BasketTotal from "$lib/components/BasketOverview/BasketTotal/BasketTotal.svelte";
  import { cart } from "$lib/stores/cart";
  import type { RegionStore } from "$lib/stores/region";

  export let regionInfo: RegionStore;

  export let isMobile: boolean;
  const sendCheckout = () => {
    window.document.body.classList.toggle("locked");
    cart.checkout($cart?.checkoutUrl, regionInfo);
  };
</script>

<style lang="scss">
  .items {
    display: flex;
    flex-direction: column;

    overflow-y: scroll;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  }
  .content {
    padding: 1.75rem;
    display: flex;
    flex-direction: column;
  }

  .col-hr {
    background: $on-surface-10;
    height: 1px;
    width: 100%;
  }

  .basket--totals {
    padding-top: 2rem;
  }
</style>

<div class="content">
  {#if $cart?.lines.edges.length > 0}
    <div class="items" style={`max-height: ${isMobile ? "19rem" : "29.5rem"}`}>
      {#each $cart?.lines.edges as item (item.node.id)}
        <div class="basket--item">
          <BasketItem
            item={item.node}
            on:change={event => {
              const findUrl = item.node?.attributes?.find(
                attribute => attribute.key === "_url",
              );
              const itemUrl = findUrl?.value || "bag";
              const canonicalUrl =
                item.node?.merchandise?.product?.canonicalUrl?.value;
              cart.setQuantity(
                $cart.id,
                [
                  {
                    id: item.node.id,
                    merchandiseId: item.node.merchandise.id,
                    quantity: event.detail,
                    attributes: [
                      {
                        key: "_url",
                        value: canonicalUrl ? canonicalUrl : itemUrl,
                      },
                    ],
                  },
                ],
                regionInfo,
              );
            }}
            on:itemSelection={() => {
              pushGtmEcommerceEvent("select_item", [item]);
            }}
          />
        </div>
      {/each}
    </div>

    <div class="col-hr" />
    <div class="basket--totals">
      <div class="basket--totals__inner">
        <BasketTotal
          on:click={() => sendCheckout()}
          totalPrice={$cart?.cost?.totalAmount}
          continueButton={false}
        />
      </div>
    </div>
  {/if}
</div>
